import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-01jurassic_horizalign_center",
  "use": "icon-01jurassic_horizalign_center-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-01jurassic_horizalign_center\"><path d=\"M480 64h64v896h-64z\" fill=\"#727272\" /><path d=\"M256 192h512v256H256z\" fill=\"#B3B3B3\" /><path d=\"M128 576h768v256H128z\" fill=\"#497CAD\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol